import React from 'react';
import useBodega from '../../utils/hooks/bodegaHook';
import { BODEGA_DEFAULTS } from '../../constants';
import useLocale from '../../utils/hooks/localeHook';
import { Unite } from '../../../constants';
import getUrl from '../../utils/url';

export default function PrivacyPolicyLink() {
  const { country, language } = useLocale();

  // In the event we have a country that doesn't have a privacy policy url, map them here.
  const nonCountryMap = {
    XL: 'CL',
  };

  const countryForUrl = nonCountryMap[country] || country;
  const privacyPolicyUrl = getUrl('privacy_policy', {
    uxId: Unite.DOTCOM_UX_ID,
    country: countryForUrl,
    language,
  });

  return (
    <a href={privacyPolicyUrl} rel="noopener noreferrer" target="_blank">
      {useBodega(
        'nav_cookie_label_privacyPolicy',
        BODEGA_DEFAULTS.COOKIE_MODAL_PRIVACY_POLICY_LINK,
      )}
    </a>
  );
}
